
export enum DevicesVctGenericType {
    PLANT = 'PLANT',
    VIDEOUNIT = 'VIDEOUNIT',
    APP = 'APP',
}


/* MODULI
1   Posto Esterno		PE	external.png	Targa	2	6
2	Unità Videocitofonica		UV	internal.png	VideoUnit	1	6
3	Unità Condominio		UC	internal.png	Building	1	6
4	Gruppo portieri		PG	pg.png	PorterGroup	1	6*/


export enum DevicesVctModules {
    Targa = 1,
    VideoUnit = 2,
    Building = 3,
    PorterGroup = 4,
}


/* FEATURES
1	Autoinserimento	AI	look_outside.png	SelfInsertion
2	Apriporta	AP	open_door.png	OpenDoor
3	Derivato interno 	DI	call.png	InternalDevice
4	App	VE	call.png	App
5	Unità Videocitofonica	UV	global_call.png	VideoUnit
6	Portiere	PT	call.png	Porter
7	Gruppo portieri	PG	pg.png	PorterGroup
8	Aux 1	AUX	light.png	Aux1
9	Aux 2	AUX	light.png	Aux2
10	Aux 3	AUX	light.png	Aux3
11	Aux 4	AUX	light.png	Aux4
12	Aux 5	AUX	light.png	Aux5
13	Aux 6	AUX	light.png	Aux6
14	Aux 7	AUX	light.png	Aux7
15	Aux 8	AUX	light.png	Aux8
16	Aux 9	AUX	light.png	Aux9
17	Aux 10	AUX	light.png	Aux10*/

export enum DevicesVctFeatures {
    SelfInsertion = 1,
    OpenDoor = 2,
    InternalDevice = 3,
    App = 4,
    VideoUnit = 5,
    Porter = 6,
    PorterGroup = 7,
    Aux1 = 8,
    Aux2 = 9,
    Aux3 = 10,
    Aux4 = 11,
    Aux5 = 12,
    Aux6 = 13,
    Aux7 = 14,
    Aux8 = 15,
    Aux9 = 16,
    Aux10 = 17,
}


/*
1	sipAccount	string	1
2	bptl3addr	string	1
3	sipAccount	string	0
4	bptl3addr	string	0
5	enableRemoteCommands	string	1
6	icon	string	1*/


export enum DevicesVctSettings {
    SipAccount1 = 1,
    Bptl3addr1 = 2,
    SipAccount0 = 3,
    Bptl3addr0 = 4,
    EnableRemoteCommands1 = 5,
    Icon1 = 6,
}

export const DEVICE_VCT_PANEL_FEATURES_EDIT_LIST = [
    DevicesVctFeatures.SelfInsertion,
    DevicesVctFeatures.OpenDoor,
    DevicesVctFeatures.Aux1,
    DevicesVctFeatures.Aux2,
    DevicesVctFeatures.Aux3,
    DevicesVctFeatures.Aux4,
    DevicesVctFeatures.Aux5,
    DevicesVctFeatures.Aux6,
    DevicesVctFeatures.Aux7,
    DevicesVctFeatures.Aux8,
    DevicesVctFeatures.Aux9,
    DevicesVctFeatures.Aux10,
];


export const DEVICE_VCT_AUX_LIST = [
    { value: 8, label: 'AUX1' },
    { value: 9, label: 'AUX2' },
    { value: 10, label: 'AUX3' },
    { value: 11, label: 'AUX4' },
    { value: 12, label: 'AUX5' },
    { value: 13, label: 'AUX6' },
    { value: 14, label: 'AUX7' },
    { value: 15, label: 'AUX8' },
    { value: 16, label: 'AUX9' },
    { value: 17, label: 'AUX10' },
];
